import { schema } from 'normalizr'

const restaurantSeat = new schema.Entity('restaurantSeats')

export default restaurantSeat
